import gql from 'graphql-tag';

import AssetDetailsFragment from '@/graphql/fragments/AssetDetails.gql';
import BaseCompany from '@/graphql/fragments/BaseCompany.gql';
import BaseUser from '@/graphql/fragments/BaseUser.gql';

export {
  AssetDetailsFragment,
  BaseCompany,
  BaseUser,
};

export const EventDetailsFragment = gql`
  fragment EventDetails on Event {
    id
    handle
    title
    description
    startDate
    endDate

    headline: leaderboard {
      prizes {
        first {
          title
          image {
            id
            fileName
            fileLocation
          }
        }
        text
      }
    }

    branding {
      logo {
        id
        fileName
        fileLocation
        fileSize
        status
      }
      socialImage {
        id
        fileName
        fileLocation
        fileSize
        status
      }
      headerFont
      bodyFont
      primaryColour
      secondaryColour
      backgroundColour
      customCSS
      customJS
    }

    customFields
    preferences

    createdAt
    updatedAt
    status
  }
`;

export const UserScheduledPostDetailsFragment = gql`
  fragment UserScheduledPostDetails on UserScheduledPost {
    id
    event {
      id
    }
    job {
      id
    }
    contentShare {
      id
    }
    createdAt
    sendAt
  }
`;



// WEBPACK FOOTER //
// ./src/graphql.js